import React, { useState, useEffect } from "react";
import {
    Typography,
    TextField,
    Button,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Stepper,
    Step,
    StepLabel,
    Grid,
} from "@mui/material";
import StepCircle from "../StepCircle";
import api from "../../api";

const steps = ["Detalles del Documento", "Asignar Vehículo"];

const tipoOpciones = [
    { value: "cedula", label: "Cédula del Vehículo" },
    { value: "seguro", label: "Póliza de Seguro" },
    { value: "permiso", label: "Permiso de Circulación" },
    { value: "vtv", label: "Verificación Técnica Vehicular (VTV)" },
    { value: "grabado_autopartes", label: "Grabado de Autopartes" },
    { value: "informe_estado", label: "Informe de Estado Técnico" },
    { value: "tarjeta_ypf", label: "Tarjeta YPF" },
    { value: "otro", label: "Otro" },
];

const EditarDocumentacion = ({ documentacion, handleClose, onUpdate }) => {
    const [step, setStep] = useState(0);
    const [vehiculos, setVehiculos] = useState([]);
    const [isStep1Valid, setIsStep1Valid] = useState(false);

    const tipoCoberturaOpciones = [
        { value: "todo_riesgo", label: "Todo Riesgo Sin Franquicia" },
        { value: "garage", label: "Garage" },
        { value: "n_a", label: "N/A" },
    ];

    const [form, setForm] = useState({
        tipo: "",
        numero: "",
        suma_asegurada: "",
        tipo_cobertura: "",
        fecha_emision: "",
        fecha_vencimiento: "",
        observaciones: "",
        archivo: null,
        vehiculo: "",
    });

    useEffect(() => {
        if (documentacion) {
            console.log("Tipo cobertura recibido:", documentacion.tipo_cobertura);
            setForm({
                tipo: documentacion.tipo || "",
                numero: documentacion.numero || "",
                suma_asegurada: documentacion.suma_asegurada || "",
                tipo_cobertura: documentacion.tipo_cobertura || "",
                fecha_emision: documentacion.fecha_emision || "",
                fecha_vencimiento: documentacion.fecha_vencimiento || "",
                observaciones: documentacion.observaciones || "",
                archivo: null,
                vehiculo: documentacion.vehiculo || "",
            });
        }
    }, [documentacion]);

    useEffect(() => {
        api.get("vehiculos/")
            .then((res) => setVehiculos(res.data))
            .catch(() => alert("Error al cargar vehículos"));
    }, []);

    useEffect(() => {
        const { tipo, fecha_emision } = form;
        setIsStep1Valid(tipo);
    }, [form]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setForm({ ...form, archivo: e.target.files[0] });
    };

    const handleNext = () => {
        setStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setStep((prev) => prev - 1);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();
        Object.entries(form).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
                formData.append(key, value);
            }
        });

        api
            .put(`documentos/${documentacion.id}/`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
                alert("Documentación actualizada correctamente");
                if (onUpdate) {
                    onUpdate(res.data); // send the new data to parent
                }
                handleClose();
            })
            .catch(() => alert("Error al actualizar la documentación"));
    };

    if (!documentacion) {
        return <Typography>Cargando documentación...</Typography>;
    }

    return (
        <form onSubmit={handleSubmit} style={{ maxWidth: 500, margin: "0 auto" }}>
            <Typography variant="h6" sx={{ color: "#152d51", fontWeight: "bold" }}>
                Editar Documentación
            </Typography>

            <Stepper activeStep={step} alternativeLabel>
                {steps.map((label, index) => (
                    <Step key={index}>
                        <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            {step === 0 && (
                <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item xs={6}>
                        <FormControl fullWidth required>
                            <InputLabel>Tipo</InputLabel>
                            <Select
                                name="tipo"
                                value={form.tipo}
                                onChange={handleChange}
                                label="Tipo"
                            >
                                {tipoOpciones.map((op) => (
                                    <MenuItem key={op.value} value={op.value}>
                                        {op.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Número (opcional)"
                            name="numero"
                            value={form.numero}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>

                    {form.tipo === "seguro" && (
                        <>
                            <Grid item xs={6}>
                                <TextField
                                    label="Suma Asegurada"
                                    name="suma_asegurada"
                                    type="number"
                                    value={form.suma_asegurada}
                                    onChange={handleChange}
                                    fullWidth
                                    InputProps={{ inputProps: { min: 0 } }}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <InputLabel>Tipo de Cobertura</InputLabel>
                                    <Select
                                        name="tipo_cobertura"
                                        value={form.tipo_cobertura}
                                        onChange={handleChange}
                                        label="Tipo de Cobertura"
                                    >
                                        {tipoCoberturaOpciones.map((op) => (
                                            <MenuItem key={op.value} value={op.value}>
                                                {op.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </>
                    )}

                    <Grid item xs={6}>
                        <TextField
                            label="Fecha de Emisión"
                            name="fecha_emision"
                            type="date"
                            value={form.fecha_emision}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            label="Fecha de Vencimiento"
                            name="fecha_vencimiento"
                            type="date"
                            value={form.fecha_vencimiento}
                            onChange={handleChange}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Observaciones"
                            name="observaciones"
                            value={form.observaciones}
                            onChange={handleChange}
                            fullWidth
                            multiline
                            rows={3}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Button variant="outlined" component="label" fullWidth>
                            Seleccionar Archivo...
                            <input type="file" hidden onChange={handleFileChange} />
                        </Button>
                        {form.archivo ? (
                            <Typography variant="caption">{form.archivo.name}</Typography>
                        ) : documentacion.archivo ? (
                            <Typography variant="caption">
                                Archivo actual: {documentacion.archivo.split("/").pop()}
                            </Typography>
                        ) : null}
                    </Grid>

                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={handleNext}
                            sx={{ backgroundColor: "#152d51" }}
                            disabled={!isStep1Valid}
                        >
                            Siguiente
                        </Button>
                    </Grid>
                </Grid>
            )}

            {step === 1 && (
                <Grid container spacing={2} sx={{ mt: 2 }}>
                    <Grid item xs={12}>
                        <FormControl fullWidth required>
                            <InputLabel>Vehículo</InputLabel>
                            <Select
                                name="vehiculo"
                                value={form.vehiculo}
                                onChange={handleChange}
                                label="Vehículo"
                            >
                                {vehiculos.map((v) => (
                                    <MenuItem key={v.id} value={v.id}>
                                        {v.patente} - {v.marca} {v.modelo}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                        <Button variant="outlined" fullWidth onClick={handleBack}>
                            Atrás
                        </Button>
                    </Grid>

                    <Grid item xs={6}>
                        <Button
                            type="submit"
                            variant="contained"
                            fullWidth
                            sx={{ backgroundColor: "#152d51" }}
                        >
                            Guardar Cambios
                        </Button>
                    </Grid>
                </Grid>
            )}
        </form>
    );
};

export default EditarDocumentacion;
